export default __webpack_public_path__ + "static/media/excellentbalance.96364e85.png";